export default __webpack_public_path__ + "static/news2-ef500a1a21873cfaa4a8fefb24d6f60c.png";